import { FlexBox } from '@ardoq/layout';
import styled from 'styled-components';
import { connect } from '@ardoq/rxbeach';
import { Icon, IconSize } from '@ardoq/icons';
import { colors, shadowL } from '@ardoq/design-tokens';
import { contextToolBar$ } from './contextToolBar$';
import { ContextToolBarAction, CurrentToolbarContext } from './types';
import { CurrentSelection } from './CurrentSelection';
import { Button } from '@ardoq/button';

const Wrapper = styled(FlexBox)`
  bottom: 0;
  left: 0;
  width: 100%;
  align-items: stretch;
  z-index: 2;
`;

const Container = styled(FlexBox)`
  border: 1px solid ${colors.borderAction};
  box-shadow: ${shadowL};
`;

type ContextToolBarProps = {
  currentContext: CurrentToolbarContext | null;
  actions: ContextToolBarAction[];
  showContextSummary: boolean;
  isToolBarHidden: boolean;
};

const ContextToolBarBase = ({
  currentContext,
  actions,
  showContextSummary,
  isToolBarHidden,
}: ContextToolBarProps) => {
  if (isToolBarHidden) return null;

  return (
    <Wrapper
      width="full"
      position="absolute"
      align="center"
      justify="center"
      marginBottom="xlarge"
      flexDirection="row"
    >
      <Container
        position="relative"
        borderRadius="medium"
        backgroundColor="bgDefault"
        padding="small"
      >
        {showContextSummary && currentContext && (
          <CurrentSelection currentContext={currentContext} />
        )}
        <FlexBox align="center" gap="xsmall" borderRadius="small">
          {actions.map(action => (
            <Button
              buttonType={action.buttonType}
              isDisabled={action.disabled}
              key={action.label}
              onClick={action.onClick}
              isActive={action.selected}
              title={action.label}
            >
              <Icon
                iconName={action.icon}
                color={action.iconColor}
                size={IconSize.SMALL}
              />
              {action.label}
            </Button>
          ))}
        </FlexBox>
      </Container>
    </Wrapper>
  );
};

export const ContextToolBar = connect(ContextToolBarBase, contextToolBar$);
